/**
 * Whether fewer credits are left than an action uses. Credits not loaded yet,
 * or with no count, don't count as short.
 */
export const isShortOfCredits = (
  creditsLeft: number | null | undefined,
  needed: number,
) => creditsLeft != null && creditsLeft < needed;

/** Whether no credits are left at all. */
export const hasNoCreditsLeft = (creditsLeft: number | null | undefined) =>
  isShortOfCredits(creditsLeft, 1);

/**
 * Explains that the workspace's enrichment providers may run an enrichment
 * instead of the credits it uses.
 */
export const getEnrichmentProvidersHint = (credits: 'email' | 'phone') =>
  `Your enrichment providers may be used instead of your ${credits} credits, depending on your settings.`;
